/**
 * Dropdown用のオプションメニュー
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import OptionState from './OptionState'

class AccountTitleGroupOptionState extends Record(OptionState) {
  mergeModel(model) {
    return this.merge({
      label: model.name,
      value: model.id
    })
  }
}

export default AccountTitleGroupOptionState
